import {createContext} from "react";

type CreateFolderDialogContextType = {
    /**
     * Is dialog opened?
     * @author Kacper Faber
     * @since 0.1.9
    */
    isOpened: boolean;

    /**
     * Change opened state.
     * @author Kacper Faber
     * @since 0.1.9
    */
    setOpened: (isOpened: boolean) => void;
};

const notImplemented = () => {
    throw new Error('Not implemented');
}

/**
 * Defaults for CreateFolderDialogContext
 * @author Kacper Faber
 * @since 0.1.9
*/
const defaults: CreateFolderDialogContextType = {
    isOpened: false,
    setOpened: notImplemented
};

const ctx = createContext<CreateFolderDialogContextType>(defaults);

export default ctx;